import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import CardInput from 'modules/billing/components/Inputs/Card'
import type SubscriptionForm from 'modules/billing/lib/forms/SubscriptionForm'

import MoreInfo from './MoreInfo'
import SecureLogos from './SecureLogos'

interface Props {
  form: SubscriptionForm
}

const CreditCardStep = ({ form }: Props) => {
  const {
    access: { fullName: accessFullName },
  } = useCurrentSession()

  return (
    <>
      <FormRow>
        <CardInput onReady={(el) => el.focus()} label={i18n.t('billing.payment.credit_card')} />
      </FormRow>
      <FormRow>
        <Text
          placeholder={accessFullName}
          label={i18n.t('billing.payment.credit_card_holder')}
          field={form.get('name')}
        />
      </FormRow>
      <FormRow>
        <MoreInfo />
      </FormRow>
      <SecureLogos />
    </>
  )
}

export default observer(CreditCardStep)
